export default __webpack_public_path__ + "static/15-ea93343f96961bbda7088b8e8f0966cf.jpg";